/** `value` held within `min` and `max`, both included. */
export const clamp = (value: number, min: number, max: number): number =>
  Math.min(Math.max(value, min), max)
